export enum RouteType {
  Container,
  Page
}
